import { Box, SimpleGrid } from 'ui/Layout';
import Skeleton from 'ui/Skeleton';

import { Sankey } from '../../generated-api';
import DiagramCard from './DiagramCard';

type Props = {
  isLoading: boolean;
  diagrams: Sankey[];
  selectedDiagramId: number | undefined;
  onClick: (id: number) => void;
  onDoubleClick: (id: number) => void;
};

const DiagramsCards: React.FC<Props> = ({
  isLoading,
  diagrams,
  selectedDiagramId,
  onClick,
  onDoubleClick,
}) => {
  return (
    <SimpleGrid columns={{ base: 1, sm: 2, lg: 3 }} gap={4}>
      {isLoading ? (
        <>
          <Skeleton.Row height="200px" />
          <Skeleton.Row height="200px" />
          <Skeleton.Row height="200px" />
        </>
      ) : (
        diagrams.map((diagram) => (
          <Box key={diagram.id}>
            <DiagramCard
              diagram={diagram}
              isSelected={diagram.id === selectedDiagramId}
              onClick={() => onClick(diagram.id)}
              onDoubleClick={() => onDoubleClick(diagram.id)}
            />
          </Box>
        ))
      )}
    </SimpleGrid>
  );
};

export default DiagramsCards;
